// HelpSection.jsx
import React, { useState, useContext, useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import CloseIcon from "@mui/icons-material/Close";

import SwipeableViews from "react-swipeable-views";
import { virtualize } from "react-swipeable-views-utils";

import HelpPanel from "../GeneralComponents/HelpPanel";
import GeneralContext from "../GeneralContext/GeneralContext";
import PageButtonSimple from "../GeneralComponents/PageButtonSimple";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageButtonWhite from "../GeneralComponents/PageButtonWhite";

import PageBody from "../GeneralComponents/PageBody";

import {
  ROL_OP_ADMIN,
  ROL_OP_INS,
  ROL_ADMIN_SUBTEL,
  ROL_VAL_SUBTEL,
  ROL_ADMIN,
  ROL_REP_EES,
  ROL_REP_EES_TEMP,
} from "../../Constants/Constants";

const VirtualizeSwipeableViews = virtualize(SwipeableViews);

const VIDEO_URL_DEFAULT =
  "https://storage.googleapis.com/bs-sagec-dev-www/tutoriales/operador_instalador/manual_operador_instalador.mp4";

const VIDEO_URL_REPRESENTANTES =
  "https://storage.googleapis.com/bs-sagec-production-www/manuales/capacitacion-manual-sagec-representantes-2026.mov";


const MOCK_VIDEO_THUMB_DEFAULT = "/assets/img-autenticacion.jpg";

const ROLE_REPRESENTANTES = [ROL_REP_EES, ROL_REP_EES_TEMP];
const ROLE_OPERADORES_Y_OTROS = [
  ROL_OP_INS,
  ROL_OP_ADMIN,
  ROL_ADMIN_SUBTEL,
  ROL_VAL_SUBTEL,
];

const defaultCapsules = [
  {
    id: 1,
    title: "Actualización Operador (anular fas/fus)",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/clips/01-Actualización-Operador-anular-fas-fus.mov",
    roles: ROLE_OPERADORES_Y_OTROS,
  },
  {
    id: 2,
    title: "Operador Repaso FAS/FUS",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/clips/02-Operador-Repaso-FAS-FUS-1.mov",
    roles: ROLE_OPERADORES_Y_OTROS,
  },
  {
    id: 3,
    title: "Operador Actualizacion Inicio Home",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/clips/03-Operador-Actualizacion-Inicio-Home-1.mov",
    roles: ROLE_OPERADORES_Y_OTROS,
  },
  {
    id: 4,
    title: "Operador Actualizacion Reportes",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/clips/04-Operador-Actualizacion-Reportes-1.mov",
    roles: ROLE_OPERADORES_Y_OTROS,
  },
  {
    id: 5,
    title: "Operador Contingencia Programada",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/clips/05-Operador-Contingencia-Programada-1.mov",
    roles: ROLE_OPERADORES_Y_OTROS,
  },
  {
    id: 6,
    title: "Operador Contingencia Zonal",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/clips/07-Operador-Contingencia-Zonal-1.mov",
    roles: ROLE_OPERADORES_Y_OTROS,
  },
  {
    id: 7,
    title: "Operador Contingencia Especifica Externa",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/clips/08-Operador-Contingencia-Especifica-Externa-1.mov",
    roles: ROLE_OPERADORES_Y_OTROS,
  },
  {
    id: 8,
    title: "Operador Prefactura",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/clips/09-Operador-Prefactura-1.mov",
    roles: [ROL_OP_ADMIN, ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL],
  },
  {
    id: 9,
    title: "Operador Validaciones",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/clips/10-Operador-Validaciones-1.mov",
    roles: [ROL_OP_ADMIN, ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL],
  },
  {
    id: 10,
    title: "Operador Establecimientos",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/clips/11-Operador-Establecimientos.mov",
    roles: ROLE_OPERADORES_Y_OTROS,
  },
  {
    id: 11,
    title: "Operador Ayuda",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/clips/12-Operador-Ayuda.mov",
    roles: ROLE_OPERADORES_Y_OTROS,
  },

  // Cápsulas representantes EES
  {
    id: 102,
    title: "Representantes - Introducción",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/manuales/capacitacion-representantes-intro-01.mov",
    roles: ROLE_REPRESENTANTES,
  },
  {
    id: 103,
    title: "Representantes - FAS y FUS",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/manuales/capacitacion-representantes-fasyfus-04.mov",
    roles: ROLE_REPRESENTANTES,
  },
  {
    id: 104,
    title: "Representantes - Datos del EES",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/manuales/capacitacion-representantes-datosdelEES-02.mov",
    roles: ROLE_REPRESENTANTES,
  },
  {
    id: 105,
    title: "Representantes - Configuración de usuario",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/manuales/capacitacion-representantes-configuraciondeusuario-03.mov",
    roles: ROLE_REPRESENTANTES,
  },
  {
    id: 106,
    title: "Representantes - Ayuda y cerrar sesión",
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
    url: "https://storage.googleapis.com/bs-sagec-production-www/manuales/capacitacion-representantes-ayudaycerrarsesion-05.mov",
    roles: ROLE_REPRESENTANTES,
  },
];

const MANUALS_BY_ROLE = {
  [ROL_OP_INS]: [
    {
      title: "Manual Rol Operador",
      url: "https://storage.googleapis.com/bs-sagec-production-www/manuales/Operador%20Instalador%20-%20Manual%20SAGEC%20-%20feb2026.pdf",
      updatedAt: "feb-2026",
      buttonLabel: "Descargar Manual en PDF",
    },
  ],

  [ROL_OP_ADMIN]: [
    {
      title: "Manual Rol Operador",
      url: "https://storage.googleapis.com/bs-sagec-production-www/manuales/Manual-Operador-Admin-SAGEC-24112025.pdf",
      updatedAt: "24-11-2025",
      buttonLabel: "Descargar Manual en PDF",
    },
    {
      title: "Manual de contingencias",
      url: "https://storage.googleapis.com/bs-sagec-production-www/manuales/Contingencias-Manual-SAGEC-24112025.pdf",
      updatedAt: "10-01-2026",
      buttonLabel: "Descargar Manual de contingencias",
    },
  ],

  [ROL_ADMIN_SUBTEL]: [
    {
      title: "Manual Administrador SUBTEL",
      url: "https://dummy.sagec.cl/manual-subtel-admin.pdf",
      updatedAt: "—",
      buttonLabel: "Descargar Manual",
    },
  ],

  [ROL_VAL_SUBTEL]: [
    {
      title: "Manual Validador SUBTEL",
      url: "https://dummy.sagec.cl/manual-subtel-validador.pdf",
      updatedAt: "—",
      buttonLabel: "Descargar Manual",
    },
  ],

  [ROL_ADMIN]: [
    {
      title: "Manual Administrador General",
      url: "https://storage.googleapis.com/bs-sagec-production-www/manuales/Operador%20Instalador%20-%20Manual%20SAGEC%20-%20feb2026.pdf",
      updatedAt: "feb-2026",
      buttonLabel: "Descargar Manual",
    },
  ],

  [ROL_REP_EES]: [
    {
      title: "Manual Representante EES",
      url: "https://storage.googleapis.com/bs-sagec-production-www/manuales/Manual%20Representante%20EES%20-%20SAGEC.pdf",
      updatedAt: "2026",
      buttonLabel: "Descargar Manual en PDF",
    },
  ],

  [ROL_REP_EES_TEMP]: [
    {
      title: "Manual Representante EES",
      url: "https://storage.googleapis.com/bs-sagec-production-www/manuales/Manual%20Representante%20EES%20-%20SAGEC.pdf",
      updatedAt: "2026",
      buttonLabel: "Descargar Manual en PDF",
    },
  ],
};

const HelpSection = ({
  mainVideo = {
    title: "Video capacitación completa",
    url: VIDEO_URL_DEFAULT,
    thumb: MOCK_VIDEO_THUMB_DEFAULT,
  },
  capsules = defaultCapsules,
}) => {
  const { setPageTitle, includeRol } = useContext(GeneralContext);

  const [slideIndex, setSlideIndex] = useState(0);
  const [manualIndex, setManualIndex] = useState(0);

  const [videoModal, setVideoModal] = useState({
    open: false,
    title: "",
    url: "",
  });

  useEffect(() => {
    setPageTitle("Contacto de Soporte");
  }, [setPageTitle]);

  const isOpInstalador = includeRol([ROL_OP_INS]);
  const isOpAdmin = includeRol([ROL_OP_ADMIN]);
  const isSubtel = includeRol([ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL]);
  const isAdmin = includeRol([ROL_ADMIN]);
  const isRepresentanteEES = includeRol([
    ROL_REP_EES,
    ROL_REP_EES_TEMP,
  ]);

  const effectiveMainVideo = useMemo(() => {
  if (isRepresentanteEES) {
    return {
      title: "Video capacitación completa",
      url: VIDEO_URL_REPRESENTANTES,
      thumb: MOCK_VIDEO_THUMB_DEFAULT,
    };
  }

  return mainVideo;
}, [isRepresentanteEES, mainVideo]);

  const showOperatorHelp =
    isOpInstalador || isOpAdmin || isSubtel || isAdmin || isRepresentanteEES;

  const manualsToShow = useMemo(() => {
    if (includeRol([ROL_ADMIN]) && MANUALS_BY_ROLE[ROL_ADMIN]) {
      return MANUALS_BY_ROLE[ROL_ADMIN];
    }
    if (includeRol([ROL_REP_EES]) && MANUALS_BY_ROLE[ROL_REP_EES]) {
      return MANUALS_BY_ROLE[ROL_REP_EES];
    }
    if (
      includeRol([ROL_REP_EES_TEMP]) &&
      MANUALS_BY_ROLE[ROL_REP_EES_TEMP]
    ) {
      return MANUALS_BY_ROLE[ROL_REP_EES_TEMP];
    }
    if (includeRol([ROL_OP_INS]) && MANUALS_BY_ROLE[ROL_OP_INS]) {
      return MANUALS_BY_ROLE[ROL_OP_INS];
    }
    if (includeRol([ROL_OP_ADMIN]) && MANUALS_BY_ROLE[ROL_OP_ADMIN]) {
      return MANUALS_BY_ROLE[ROL_OP_ADMIN];
    }
    if (
      includeRol([ROL_ADMIN_SUBTEL]) &&
      MANUALS_BY_ROLE[ROL_ADMIN_SUBTEL]
    ) {
      return MANUALS_BY_ROLE[ROL_ADMIN_SUBTEL];
    }
    if (includeRol([ROL_VAL_SUBTEL]) && MANUALS_BY_ROLE[ROL_VAL_SUBTEL]) {
      return MANUALS_BY_ROLE[ROL_VAL_SUBTEL];
    }
    return [];
  }, [includeRol]);

  const openUrl = (url) => {
    if (!url || url === "#") return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleOpenVideo = ({ title, url }) => {
    setVideoModal({
      open: true,
      title,
      url,
    });
  };

  const handleCloseVideo = () => {
    setVideoModal((prev) => ({
      ...prev,
      open: false,
      url: "",
    }));
  };

  const effectiveCapsules = useMemo(() => {
    if (!capsules?.length) return [];

    let filtered = [];

    if (isAdmin) {
      filtered = capsules;
    } else {
      filtered = capsules.filter((c) => {
        if (!Array.isArray(c.roles) || c.roles.length === 0) return true;
        return includeRol(c.roles);
      });
    }

    // Regla ya existente para instalador: ocultar prefactura
    if (isOpInstalador && !isAdmin) {
      filtered = filtered.filter(
        (c) => !c.title?.toLowerCase().includes("prefactura")
      );
    }

    return filtered;
  }, [capsules, includeRol, isAdmin, isOpInstalador]);

  const manualSlideRenderer = ({ index, key }) => {
    const n = manualsToShow.length;

    if (n === 0) {
      return (
        <Box key={key} sx={{ p: 2 }}>
          <Typography align="center">
            No hay manuales configurados para tu rol.
          </Typography>
        </Box>
      );
    }

    const i = ((index % n) + n) % n;
    const m = manualsToShow[i];

    return (
      <Box key={key} sx={{ px: 1, width: "100%", height: "100%" }}>
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 2,
              justifyContent: "center",
            }}
          >
            <SchoolOutlinedIcon
              sx={{ mr: 1.5, fontSize: 32, color: "#2196F3" }}
            />
            <Typography variant="h5" fontWeight={700}>
              {m.title}
            </Typography>
          </Box>

          <Typography variant="body2" sx={{ maxWidth: 520 }}>
            Puede descargar el último{" "}
            <strong>manual actualizado el {m.updatedAt}</strong> en{" "}
            <Link
              component="button"
              type="button"
              sx={{ fontWeight: 700, pb: "2px" }}
              onClick={() => openUrl(m.url)}
            >
              este enlace
            </Link>{" "}
            y aprender a utilizar nuestro sistema en detalle.
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "center", pt: 4 }}>
            <PageButtonSimple onClick={() => openUrl(m.url)} pad="8px 16px">
              {m.buttonLabel || "Descargar Manual en PDF"}
            </PageButtonSimple>
          </Box>
        </Box>
      </Box>
    );
  };

  const slideRenderer = ({ index, key }) => {
    const n = effectiveCapsules.length;

    if (n === 0) {
      return (
        <Box key={key} sx={{ p: 2, height: "100%" }}>
          <Typography align="center">No hay cápsulas disponibles.</Typography>
        </Box>
      );
    }

    const start = ((index % n) + n) % n;

    const visibleCapsules = [
      effectiveCapsules[start],
      effectiveCapsules[(start + 1) % n],
      effectiveCapsules[(start + 2) % n],
    ];

    return (
      <Box key={key} sx={{ px: 1, height: "100%" }}>
        <Grid container spacing={2} sx={{ height: "100%" }}>
          {visibleCapsules.map((capsule) => (
            <Grid
              key={capsule.id}
              size={{ xs: 12, sm: 4 }}
              sx={{ height: "100%", display: "flex" }}
            >
              <Box
                sx={{
                  borderRadius: 2,
                  overflow: "hidden",
                  cursor: "pointer",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
                onClick={() =>
                  handleOpenVideo({ title: capsule.title, url: capsule.url })
                }
              >
                <Box
                  component="img"
                  src={capsule.thumb}
                  alt={capsule.title}
                  sx={{
                    width: "100%",
                    aspectRatio: "16 / 9",
                    display: "block",
                    objectFit: "cover",
                    flexShrink: 0,
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    top: "40%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    pointerEvents: "none",
                  }}
                >
                  <PlayCircleFilledWhiteIcon
                    sx={{ fontSize: 64, color: "#0F69C4" }}
                  />
                </Box>

                <Box
                  sx={{
                    p: 1.5,
                    flexGrow: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="body2"
                    fontWeight={500}
                    align="center"
                  >
                    {capsule.title}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  };

  const handleNext = () => setSlideIndex((prev) => prev + 1);
  const handleBack = () => setSlideIndex((prev) => prev - 1);

  const handleManualNext = () => setManualIndex((prev) => prev + 1);
  const handleManualBack = () => setManualIndex((prev) => prev - 1);

  if (!showOperatorHelp) {
    return null;
  }

  return (
    <PageBody>
      <Box sx={{ p: 0, mb: 3 }}>
        <Grid container spacing={3} sx={{ alignItems: "stretch" }}>
          <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex" }}>
            <HelpPanel title="Manuales de Usuario">
              <Box sx={{ p: 1, height: "100%" }}>
                {manualsToShow.length <= 1 ? (
                  <Box sx={{ minHeight: 190, height: "100%", display: "flex" }}>
                    {manualSlideRenderer({ index: 0, key: "single-manual" })}
                  </Box>
                ) : (
                  <>
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "56px 1fr 56px",
                        alignItems: "stretch",
                        minHeight: 190,
                        height: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <IconButton
                          size="small"
                          onClick={handleManualBack}
                          sx={{ width: 40, height: 40 }}
                        >
                          <KeyboardArrowLeft />
                        </IconButton>
                      </Box>

                      <Box
                        sx={{
                          width: "100%",
                          overflow: "hidden",
                          height: "100%",
                        }}
                      >
                        <VirtualizeSwipeableViews
                          index={manualIndex}
                          onChangeIndex={setManualIndex}
                          enableMouseEvents
                          slideRenderer={manualSlideRenderer}
                          style={{ height: "100%" }}
                          containerStyle={{ height: "100%" }}
                          slideStyle={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                          }}
                        />
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <IconButton
                          size="small"
                          onClick={handleManualNext}
                          sx={{ width: 40, height: 40 }}
                        >
                          <KeyboardArrowRight />
                        </IconButton>
                      </Box>
                    </Box>

                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        textAlign: "center",
                        mt: 1,
                        color: "text.secondary",
                      }}
                    >
                      {(((manualIndex % manualsToShow.length) +
                        manualsToShow.length) %
                        manualsToShow.length) +
                        1}{" "}
                      / {manualsToShow.length}
                    </Typography>
                  </>
                )}
              </Box>
            </HelpPanel>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex" }}>
            <HelpPanel title={effectiveMainVideo.title || "Video capacitación completa"}>
              <Box
                sx={{
                  p: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    borderRadius: 3,
                    overflow: "hidden",
                    maxWidth: 420,
                    width: "100%",
                    bgcolor: "black",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    handleOpenVideo({
                      title: effectiveMainVideo.title,
                      url: effectiveMainVideo.url,
                    })
                  }
                >
                  <Box
                    component="img"
                    src={effectiveMainVideo.thumb || MOCK_VIDEO_THUMB_DEFAULT}
                    alt={effectiveMainVideo.title}
                    sx={{
                      width: "100%",
                      aspectRatio: "16 / 9",
                      display: "block",
                      objectFit: "cover",
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      pointerEvents: "none",
                    }}
                  >
                    <PlayCircleFilledWhiteIcon
                      sx={{ fontSize: 80, color: "#0F69C4" }}
                    />
                  </Box>
                </Box>
              </Box>
            </HelpPanel>
          </Grid>

          <Grid size={12}>
            <HelpPanel title="Cápsulas de capacitación">
              <Box sx={{ p: 2 }}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "56px 1fr 56px",
                    alignItems: "stretch",
                    minHeight: { xs: 230, md: 230 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={handleBack}
                      sx={{
                        width: 40,
                        height: 40,
                        flexShrink: 0,
                      }}
                    >
                      <KeyboardArrowLeft />
                    </IconButton>
                  </Box>

                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <VirtualizeSwipeableViews
                      index={slideIndex}
                      onChangeIndex={setSlideIndex}
                      enableMouseEvents
                      slideRenderer={slideRenderer}
                      style={{ width: "100%" }}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={handleNext}
                      sx={{
                        width: 40,
                        height: 40,
                        flexShrink: 0,
                      }}
                    >
                      <KeyboardArrowRight />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            </HelpPanel>
          </Grid>
        </Grid>
      </Box>

      <Dialog
        open={videoModal.open}
        onClose={handleCloseVideo}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ pr: 5, textAlign: "center" }}>
          {videoModal.title}
          <IconButton
            aria-label="close"
            onClick={handleCloseVideo}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {videoModal.url && (
            <>
              <Box
                component="video"
                src={videoModal.url}
                controls
                autoPlay
                sx={{
                  width: "100%",
                  borderRadius: 1,
                  outline: "none",
                }}
              />
              <Grid
                container
                spacing={2}
                justifyContent="center"
                sx={{ mt: 3, mb: 1 }}
              >
                <Grid>
                  <PageButtonWhite width="200px" onClick={handleCloseVideo}>
                    Cerrar
                  </PageButtonWhite>
                </Grid>
                <Grid>
                  <PageButtonBlack
                    width="200px"
                    onClick={() => openUrl(videoModal.url)}
                  >
                    Descargar
                  </PageButtonBlack>
                </Grid>
              </Grid>
            </>
          )}
        </DialogContent>
      </Dialog>
    </PageBody>
  );
};

export default HelpSection;